var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"membership-view view"},[_c('div',{staticClass:"container box is-small"},[_vm._v(" Vi jobbar stenhårt på att få denna sida att fungera. Återkom senare. "),_c('br'),_c('RouterLink',{staticClass:"button is-text has-top-margin",attrs:{"to":{ name: 'home' }}},[_vm._v("Till startsidan")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }